var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{},[_c('v-main',{staticClass:"print-margin"},[_c('div',{staticClass:"d-flex justify-center mid"},[_c('nuxt')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }